import Loading from '@@/core/components/shared/Loading/Loading'
import mixins from '@@/core/mixins/mixins'
import FormModal from "@@/core/libraries/form/FormModal";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";
import {BButton, BCard, BCollapse, BFormGroup, BFormInput, BTable, BTooltip, VBToggle} from "bootstrap-vue";

export default {
    name: "WearehouseManagement",
    components: {
    FormModal,
    Loading,
    BTooltip, BButton, BCollapse, BCard, BFormGroup, BFormInput, BTable,
    ProductSearch, 
    },
    directives: {
    'b-toggle': VBToggle,
    },
    mixins: [mixins],
    data() {
        return {
            productSelect: null,  
            destinationAgency: null,
            isButtonDisabled: false,
            productSku: "", 
            product: "", 
            productId: "",
        }
    },
    methods: {
        selectProduct(product) {
            if(this.product){
                this.$root.notify(
                    "بیشتر از یک محصول نمیشه وارد کرد.",
                    "warning"
                );
                return;
            }
            this.product = product;
            this.product.varieties.forEach(variety => {  
                const foundBalance = variety.quantity;  
                variety.quantity = foundBalance ?? 0;  
            });  
        },
        async requestProduct() {
            try {
                if(this.product){
                    this.$root.notify(
                        "بیشتر از یک محصول نمیشه وارد کرد.",
                        "warning"
                    );
                    return;
                }
                this.disabled = true;
                const response = await this.$axios.get("admin/mini_orders/search", {
                    params: {
                        sku: this.productSku,
                        refund: false,
                    },
                });
                const variety = response.data.data.variety;
                const productId = variety.product.id;
                const responseProduct = await this.$axios.get("admin/products/" + productId);
                this.product = responseProduct.data.data.product;
                this.product.varieties.forEach(variety => {  
                    const foundBalance = variety.quantity;  
                    variety.quantity = foundBalance ?? 0;  
                });
                
            } catch (e) {
                this.$root.notify(e);
            } finally {
                this.disabled = false;
                this.$nextTick(() => {  
                    this.$refs.productSku.focus();  
                });  
            }
        },
        async submitData() {  
            const data = {  
                product_id: this.product.id,  
                varieties: this.product.varieties.map(variety => ({  
                    id: variety.id,  
                    balance: variety.quantity,  
                }))  
            };  

            try {  
                const response = await this.$axios.post('admin/store-taking',data);  
                this.$root.notify(response.data.message, 'success');
                this.product = null; 
            } catch (error) {  
                this.$root.notify(error)
            }  
        }  
    }
}
